<i18n>
  {
    "pt_BR": {
      "plan": {
        "5": "Opção para Homologação",
        "500": "Melhor opção quando você quer testar se a sua base responde bem aos SMSs.",
        "1500": "O melhor custo-benefício, para você atingir ainda mais leads com SMS.",
        "5000": "Pense grande e vá mais longe com campanhas mais enriquecidas!",
        "10000": "Quando as campanhas começam a dar resultados, você precisa ter saldo para acompanhar o crescimento.",
        "25000":" O saldo SMS não expira, quanto maior o pacote SMS, menor será o custo por mensagem.",
        "50000": "Supreender os leads em todas as etapas do funil de vendas, com CTAs por SMS para incrementar todos os fluxos.",
        "100000": "Para grandes empresas que cuidam dos seus leads.",
        "500000": "Poucas empresas zelam tanto por seus leads e clientes.",
        "1000000": "Especial para cuidar bem dos leads, clientes, fornecedores e colaboradores."
      },
      "providers": {
        "paypal": "Paypal",
        "pagseguro": "Pagseguro"
      },
      "loading": "Gerando fatura...",
      "buy": "Comprar com {0}"
    }
  }
</i18n>

<template>
  <section class="package_list" style="margin-top: 20px;">
    <div class="row justify-content-center">

      <div class="col-auto">
                <div class="package-card essential">
                  <div class="package-card--header">
                    <p class="package-title">500 SMS</p>
                    <div class="package-price"><span class="package-price--currency">R$</span><span class="package-price--number">90</span><span class="package-price--decimals">,00</span></div>
                  </div>
                  <div class="package-card--content">
                    <div class="package-amount">
                      <p><span>500</span>SMS</p>
                    </div>
                    <div class="package-description">Melhor opção quando você quer testar se a sua base responde bem aos SMSs</div>
                    <input class="input package-cta" type="button" name="submit" alt="Comprar o pacote de 500 - RD SMS" value="Comprar" onclick="window.open('https://www.asaas.com/c/970246617261','_self');"/>
                  </div>
                </div>
        </div>
        <div class="col-auto">
                <div class="package-card starter">
                  <div class="package-card--header">
                    <p class="package-title">1500 SMS</p>
                    <div class="package-price"><span class="package-price--currency">R$</span><span class="package-price--number">225</span><span class="package-price--decimals">,00</span></div>
                  </div>
                  <div class="package-card--content">
                    <div class="package-amount">
                      <p><span>1500</span>SMS</p>
                    </div>
                    <div class="package-description">O melhor custo-benefício, para você atingir ainda mais leads com SMS.</div>
                    <input class="input package-cta" type="button" name="submit" alt="Comprar o pacote de 1500 - RD SMS" value="Comprar" onclick="window.open('https://www.asaas.com/c/021181549832','_self');"/>
                  </div>
                </div>
        </div>
        <div class="col-auto">
                <div class="package-card premium">
                  <div class="package-card--header">
                    <p class="package-title">5000 SMS</p>
                    <div class="package-price"><span class="package-price--currency">R$</span><span class="package-price--number">750</span><span class="package-price--decimals">,00</span></div>
                  </div>
                  <div class="package-card--content">
                    <div class="package-amount">
                      <p><span>5000</span>SMS</p>
                    </div>
                    <div class="package-description">Pense grande e vá mais longe com campanhas mais enriquecidas!</div>
                    <input class="input package-cta" type="button" name="submit" alt="Comprar o pacote de 5000 - RD SMS" value="Comprar" onclick="window.open('https://www.asaas.com/c/341482752448','_self');"/>
                  </div>
                </div>
        </div>
        <div class="col-auto">
                <div class="package-card premium1">
                  <div class="package-card--header">
                    <p class="package-title">10.000 SMS</p>
                    <div class="package-price"><span class="package-price--currency">R$</span><span class="package-price--number">1.500</span><span class="package-price--decimals">,00</span></div>
                  </div>
                  <div class="package-card--content">
                    <div class="package-amount">
                      <p><span>10.000</span>SMS</p>
                    </div>
                    <div class="package-description">Quando as campanhas começam a dar resultados, você precisa ter saldo para acompanhar o crescimento</div>
                    <input class="input package-cta" type="button" name="submit" alt="Comprar o pacote de 10.000 - RD SMS" value="Comprar" onclick="window.open('https://www.asaas.com/c/843791949623','_self');"/>
                  </div>
                </div>
        </div>
        <div class="col-auto">
                <div class="package-card premium2">
                  <div class="package-card--header">
                    <p class="package-title">25.000 SMS</p>
                    <div class="package-price"><span class="package-price--currency">R$</span><span class="package-price--number">3.250</span><span class="package-price--decimals">,00</span></div>
                  </div>
                  <div class="package-card--content">
                    <div class="package-amount">
                      <p><span>25.000</span>SMS</p>
                    </div>
                    <div class="package-description">O saldo SMS não expira, quanto maior o pacote SMS, menor será o custo por mensagem.</div>
                    <input class="input package-cta" type="button" name="submit" alt="Comprar o pacote de 25.000 - RD SMS" value="Comprar" onclick="window.open('https://www.asaas.com/c/876905153146','_self');"/>
                  </div>
                </div>
        </div>
        <div class="col-auto">
                <div class="package-card premium3">
                  <div class="package-card--header">
                    <p class="package-title">50.000 SMS</p>
                    <div class="package-price"><span class="package-price--currency">R$</span><span class="package-price--number">5.500</span><span class="package-price--decimals">,00</span></div>
                  </div>
                  <div class="package-card--content">
                    <div class="package-amount">
                      <p><span>50.000</span>SMS</p>
                    </div>
                    <div class="package-description">Supreender os leads em todas as etapas do funil de vendas, com CTAs por SMS para incrementar todos os fluxos</div>
                    <input class="input package-cta" type="button" name="submit" alt="Comprar o pacote de 50.000 - RD SMS" value="Comprar" onclick="window.open('https://www.asaas.com/c/485040493680','_self');"/>
                  </div>
                </div>
        </div>
        <div class="col-auto">
                <div class="package-card premium4">
                  <div class="package-card--header">
                    <p class="package-title">100.000 SMS</p>
                    <div class="package-price"><span class="package-price--currency">R$</span><span class="package-price--number">11.000</span><span class="package-price--decimals">,00</span></div>
                  </div>
                  <div class="package-card--content">
                    <div class="package-amount">
                      <p><span>100.000</span>SMS</p>
                    </div>
                    <div class="package-description">Para grandes empresas que cuidam dos seus leads</div>
                    <input class="input package-cta" type="button" name="submit" alt="Comprar o pacote de 100.000 - RD SMS" value="Comprar" onclick="window.open('https://www.asaas.com/c/689211791996','_self');"/>
                  </div>
                </div>
        </div>
        <div class="col-auto">
                <div class="package-card premium5">
                  <div class="package-card--header">
                    <p class="package-title">500.000 SMS</p>
                    <div class="package-price"><span class="package-price--currency">R$</span><span class="package-price--number">45.000</span><span class="package-price--decimals">,00</span></div>
                  </div>
                  <div class="package-card--content">
                    <div class="package-amount">
                      <p><span>500.000</span>SMS</p>
                    </div>
                    <div class="package-description">Poucas empresas zelam tanto por seus leads e clientes.</div>
                    <input class="input package-cta" type="button" name="submit" alt="Comprar o pacote de 500.000 - RD SMS" value="Comprar" onclick="window.open('https://www.asaas.com/c/181519701229','_self');"/>
                  </div>
                </div>
        </div>
      
      <!--
      <div class="col-auto" :key="plan.price" v-for="plan in filtered">
        <div class="package-card" :class="getConfig(plan.quantity).class">
          <div class="package-card--header">
            <p class="package-title">{{ plan.quantity }} SMS</p>
            <div class="package-price"><span class="package-price--currency">R$</span><span class="package-price--number" v-text="plan.price / 100"></span><span class="package-price--decimals">,00</span></div>
          </div>
          <div class="package-card--content">
            <div class="package-amount">
              <p><span v-text="plan.quantity"></span>SMS</p>
            </div>
            <div class="package-description" v-t="'plan.' + plan.quantity"></div>

            <div :key="provider" v-for="(provider, index) in providers">
              <input
                :style="{ marginTop: index == 0 ? '0' : '20px' }"
                :alt="$t('buy', [ $t('providers.' + provider) ])"
                :value="plan[provider] ? $t('loading') : $t('buy', [ $t('providers.' + provider) ])"
                @click.prevent="buy(provider, plan)"
                class="input package-cta btnCompraPagSeguro"
                :class="provider"
                id="btnCompra5"
                type="button"
                name="submit" >

                <a style="margin-top: 20px" class="input pj package-cta btnCompraPagSeguro" href="http://conteudo.chagbrasil.com/rd-sms-solicitacao-de-boleto-de-pacote-para-pj" target="_blank">
                  Comprar Pessoa Jurídica
                </a>
            </div>
          </div>
        </div>     
      </div>
      -->

    </div>
  </section>
</template>

<script>
  import Axios from 'core/axios';
  import { mapState } from 'vuex';
  import Config from 'core/config';

  const loaded = {};

  export default {
    created () {
      this.setup();
      this.fetch();
    },

    data: () => ({
      plans: [],
      providers: [],
    }),

    computed: {
      ...mapState('auth', [
        'user',
      ]),

      config () {
        return {
          5: {
            class: 'essential',
          },
          500: {
            class: 'essential',
          },
          1500: {
            class: 'starter',
          },
          5000: {
            class: 'premium',
          },
          10000: {
            class: 'premium1',
          },
          25000: {
            class: 'premium2',
          },
          50000: {
            class: 'premium3',
          },
          100000: {
            class: 'premium4',
          },
          500000: {
            class: 'premium5',
          },
          1000000: {
            class: 'premium6',
          },
        };
      },

      filtered () {
        const hasChagEmail = this.user && this.user.email.endsWith('chagbrasil.com');

        return this.plans.filter(({ price }) => {
          if (hasChagEmail) {
            return true;
          }

          return price > 100;
        });
      },
    },

    methods: {
      fetch () {
        Axios.get('plan')
          .then(({ data }) => data)
          .then(({ plans, providers }) => {
            this.plans = plans.map((plan) => {
              plan.paypal = false;
              plan.pagseguro = false;

              return plan;
            });

            this.providers = providers.filter(provider => provider !== 'paypal');
          });
      },

      getConfig (quantity) {
        return this.config[quantity];
      },

      post (provider, data) {
        return Axios.post('invoice/' + provider, data)
          .then(({ data }) => {
            if (Object.keys(data).length == 0) {
              throw new Error('');
            }

            return data;
          });
      },

      buy (provider, plan) {
        plan[provider] = true;

        const self = this;

        this.post(provider, { quantity: plan.quantity })
          .then((data) => {
            if (provider == 'pagseguro') {
              const flag = PagSeguroLightbox(data, {
                success: () => self.push('/invoice'),
                abort: () => plan[provider] = false,
              });

              if (! flag) {
                location.href='https://pagseguro.uol.com.br/v2/checkout/payment.html?code=' + code;
              }
            }

            if (provider == 'paypal') {
              window.paypal.setup({
                env: Config.env,
              });

              window.paypal.checkout.startFlow(data.approval_url);
            }
          })
          .catch(() => plan[provider] = false);

      },

      load (url) {
        if (loaded[url]) {
          return Promise.resolve();
        }

        return new Promise((resolve) => {
          new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = url;
            script.onload = () => {
              loaded[url] = true;

              resolve();
            };
            script.onerror = reject;
            document.head.appendChild(script);
          });
        });
      },

      setup () {
        this.load(Config.pagseguro[Config.env]);
        // this.load(Config.paypal.url);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Plan/Plan.vue